import React from 'react';
import Header from 'app/components/layout/Header';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Progress, Badge, Label } from 'reactstrap';
import Isvg from 'react-inlinesvg';
import moment from 'moment';
import { IPaymentRequest } from 'app/ducks/paymentRequests/types';
import { parseAmount, friendlyDate, simpleDateNoTime } from 'app/utils/parsers';
import Checkbox from 'app/components/general/Checkbox';
import Alert from 'app/components/general/Alert';
import SectionGroup from 'app/components/general/SectionGroup';
import StatusBadge from 'app/components/general/StatusBadge';
import PaymentCollectionsTableCustomers from 'app/components/payments/PaymentCollectionsTableCustomers';
import PaymentCollectionsTableTeams from 'app/components/payments/PaymentCollectionsTableTeams';
import * as paymentRequestActions from 'app/ducks/paymentRequests/actions';
import * as paymentCollectionActions from 'app/ducks/paymentCollections/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as paymentRequestsSelectors from 'app/ducks/paymentRequests/selectors';
import * as paymentCollectionsSelectors from 'app/ducks/paymentCollections/selectors';
import * as organisationsSelectors from 'app/ducks/organisations/selectors';

import CompetitionIcon from 'app/images/icons/organisation.svg';


interface IPaymentRequestDetailProps {
  actions?: any;
  match?: any;
  organisations?: any;
  paymentRequests?: any;
  paymentCollections?: any;
  appReady?: boolean;
}

interface IPaymentRequestDetailState {
  initialFilter: any;
  error?: string;
}

const formatSentAtText = (dateTime: any): string => {
  const parsedDate = simpleDateNoTime(dateTime);

  if (parsedDate === 'Invalid date') {
    return 'Sent';
  }
  return `Sent at ${parsedDate}`;
};

function selector(state) {
  return {
    paymentRequests: paymentRequestsSelectors.getPaymentRequests(state),
    paymentCollections: paymentCollectionsSelectors.getPaymentCollections(state),
    organisations: organisationsSelectors.getOrganisations(state),
    appReady: loadingSelectors.appReady(state),
  };
}

const actionCreators = _.merge(
  paymentRequestActions,
  paymentCollectionActions,
);

@connect(
  selector,
  (dispatch) => ({
    actions: bindActionCreators(actionCreators, dispatch),
  }),
)
export default class PaymentRequestDetail extends React.Component<IPaymentRequestDetailProps, IPaymentRequestDetailState> {
  static defaultProps: IPaymentRequestDetailProps = {
    actions: undefined,
    match: undefined,
    paymentRequests: undefined,
    paymentCollections: undefined,
    appReady: false,
  };

  componentDidMount(): void {
    this.props.actions.clearPaymentCollections();
    this.props.actions.getPaymentRequest(this.props.match.params.subaction);
    // this.props.actions.getAllPaymentCollections(this.props.match.params.subaction);
  }

  render(): React.ReactNode {
    const paymentRequest: IPaymentRequest = this.props.paymentRequests.currentPaymentRequest;
    const progressPercentage = paymentRequest.collectedAmount === 0
      ? 0
      : (paymentRequest.collectedAmount / paymentRequest.totalAmount) * 100;
    const isLoading = this.props.paymentRequests.isLoading && paymentRequest.id !== this.props.match.params.subaction;

    const reminderStatuses = {
      smsInitial: {
        enabled: paymentRequest.notificationConfiguration?.sendSmsInitialNotificationOrgCustomers || false,
        sent: paymentRequest.notificationLog?.sendSmsInitialNotificationOrgCustomers?.sent || false,
        text: paymentRequest.notificationLog?.sendSmsInitialNotificationOrgCustomers?.sent ? formatSentAtText(paymentRequest.notificationLog?.sendSmsInitialNotificationOrgCustomers.sentOn) : 'Not sent',
      },
      emailInitial: {
        enabled: paymentRequest.notificationConfiguration?.sendEmailInitialNotificationOrgCustomers || false,
        sent: paymentRequest.notificationLog?.sendEmailInitialNotificationOrgCustomers?.sent || false,
        text: paymentRequest.notificationLog?.sendEmailInitialNotificationOrgCustomers?.sent ? formatSentAtText(paymentRequest.notificationLog?.sendSmsInitialNotificationOrgCustomers.sentOn) : 'Not sent',
      },
      smsDue: {
        enabled: paymentRequest.notificationConfiguration?.sendSmsDueReminderOrgCustomers || false,
        sent: paymentRequest.notificationLog?.sendSmsDueReminderOrgCustomers?.sent || false,
        text: paymentRequest.notificationLog?.sendSmsDueReminderOrgCustomers?.sent ? formatSentAtText(paymentRequest.notificationLog?.sendSmsDueReminderOrgCustomers.sentOn) : 'Not sent',
      },
      emailDue: {
        enabled: paymentRequest.notificationConfiguration?.sendEmailDueReminderOrgCustomers || false,
        sent: paymentRequest.notificationLog?.sendEmailDueReminderOrgCustomers?.sent || false,
        text: paymentRequest.notificationLog?.sendEmailDueReminderOrgCustomers?.sent ? formatSentAtText(paymentRequest.notificationLog?.sendEmailDueReminderOrgCustomers.sentOn) : 'Not sent',
      },
      // sms1Day: {
      //   enabled: paymentRequest.notificationConfiguration?.sendSms1DayReminder || false,
      //   sent: paymentRequest.notificationLog?.sms1DayReminder?.sent || false,
      //   text: paymentRequest.notificationLog?.sms1DayReminder?.sent ? `Sent at ${simpleDateNoTime(paymentRequest.notificationLog?.sms1DayReminder)}` : `Will be sent on ${moment(paymentRequest.dueOn).subtract(1, 'days').format('D MMM YYYY')}`,
      // },
      // email1Day: {
      //   enabled: paymentRequest.notificationConfiguration?.sendEmail1DayReminder || false,
      //   sent: paymentRequest.notificationLog?.email1DayReminder?.sent || false,
      //   text: paymentRequest.notificationLog?.email1DayReminder?.sent ? `Sent at ${simpleDateNoTime(paymentRequest.notificationLog?.email1DayReminder)}` : `Will be sent on ${moment(paymentRequest.dueOn).subtract(1, 'days').format('D MMM YYYY')}`,
      // },
      // sms3Day: {
      //   enabled: paymentRequest.notificationConfiguration?.sendSms3DayReminder || false,
      //   sent: paymentRequest.notificationLog?.sms3DayReminder?.sent || false,
      //   text: paymentRequest.notificationLog?.sms3DayReminder?.sent ? `Sent at ${simpleDateNoTime(paymentRequest.notificationLog?.sms3DayReminder)}` : `Will be sent on ${moment(paymentRequest.dueOn).subtract(3, 'days').format('D MMM YYYY')}`,
      // },
      // email3Day: {
      //   enabled: paymentRequest.notificationConfiguration?.sendEmail3DayReminder || false,
      //   sent: paymentRequest.notificationLog?.email3DayReminder?.sent || false,
      //   text: paymentRequest.notificationLog?.email3DayReminder?.sent ? `Sent at ${simpleDateNoTime(paymentRequest.notificationLog?.email3DayReminder)}` : `Will be sent on ${moment(paymentRequest.dueOn).subtract(3, 'days').format('D MMM YYYY')}`,
      // },
    };

    return (
      <div>
        <div className="row">
          <div className="col">
            <Header
              title={paymentRequest.description}
              isLoading={isLoading}
              badge={(
                <StatusBadge
                  paymentText={paymentRequest.status}
                  formattedPaymentText={paymentRequest.status === 'pending' ? 'Collecting' : false}
                />
              )}
              descriptors={
                [
                  {
                    icon: <Isvg src={CompetitionIcon} />,
                    descriptor: paymentRequest.competitionName,
                  },
                ]
              }
              metadata={[
                {
                  title: 'Date Requested',
                  value: paymentRequest.createdAt !== undefined ? friendlyDate(paymentRequest.createdAt) : '',
                },
                {
                  title: 'Type',
                  value: paymentRequest.paymentCategory === 'individual-request' ? 'Customers' : 'Teams',
                },
                {
                  title: 'Date Due',
                  value: paymentRequest.dueAt !== undefined ? simpleDateNoTime(paymentRequest.dueAt) : '',
                },
              ]}
            />
          </div>
        </div>
        <div className="main-content">
          {paymentRequest.status === 'setting-up' && (
            <div className="row">
              <div className="col col-12 col-lg-8 col-xlg-6">
                <Alert color="info">Payment requests are currently being sent out to selected payee/s in the background. No further action is required. The data below will update as requests have been sent, you do not need to stay on this page.</Alert>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col col-12 col-lg-8 col-xlg-6">
              <SectionGroup title="Summary">
                <div className="row with-margin-top-10">
                  <div className="col">
                    <Progress multi>
                      <Progress bar color="green" value={progressPercentage} />
                      <Progress bar color="grey" value={100 - progressPercentage} />
                    </Progress>
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col text-left normal-text">
                    {parseAmount(
                      paymentRequest.collectedAmount,
                    )}
                  </div>
                  <div className="col text-right normal-text">
                    {parseAmount(
                      paymentRequest.totalAmount,
                    )}
                  </div>
                </div>
                {/* <div className="row with-margin-top-10">
                  <div className="divider full row-card-full" />
                </div>
                <div className="row with-margin-top-10">
                  <div className="col text-center medium-text text-grey">
                    <span className="text-weight-bold large-text text-black">
                      {paymentRequest.numberOfCollectedPayees}
                    </span>
                    {' '}
                    out of
                    {' '}
                    <span className="text-weight-bold medium-text large-text text-black">
                      {paymentRequest.numberOfPayees}
                    </span>
                    {' '}
                    collected
                  </div>
                </div> */}
              </SectionGroup>
            </div>
          </div>
          <div className="row with-margin-top-extra">
            <div className="col col-12 col-lg-8 col-xlg-6">
              <SectionGroup title="Details" isLoading={isLoading}>
                <div className="row">
                  <div className="col col-4 text-grey">
                    Description
                  </div>
                  <div className="col">
                    {paymentRequest.description}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Number of
                    {' '}
                    {paymentRequest.paymentCategory === 'individual-request' ? 'Customers' : 'Teams'}
                  </div>
                  <div className="col">
                    {paymentRequest.numberOfPeople}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Amount Per
                    {' '}
                    {paymentRequest.paymentCategory === 'individual-request' ? 'Customer' : 'Team'}
                  </div>
                  <div className="col">
                    {parseAmount(paymentRequest.amount)}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Total Amount Requested
                  </div>
                  <div className="col">
                    {parseAmount(paymentRequest.totalAmount)}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Total Number Collected
                  </div>
                  <div className="col">
                    {paymentRequest.collected}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Total Amount Collected
                  </div>
                  <div className="col">
                    {parseAmount(paymentRequest.collectedAmount)}
                  </div>
                </div>
                {/* <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Total Net Amount Collected
                  </div>
                  <div className="col">
                    {parseAmount(paymentRequest.totalNetAmountCollectedInCents)}
                  </div>
                </div> */}
              </SectionGroup>
            </div>
          </div>
          <div className="row with-margin-top-extra">
            <div className="col col-12 col-lg-8 col-xlg-6">
              <SectionGroup title="Notifications" isLoading={isLoading}>
                {reminderStatuses.smsInitial.enabled && (
                  <div className="row">
                    <div className="col col-4 text-grey">
                      Initial Notification (SMS)
                    </div>
                    <div className="col d-flex">
                      <Checkbox
                        className="with-label"
                        checked={reminderStatuses.smsInitial.sent}
                      />
                      <Label className="d-inline no-margin-bottom">
                        {reminderStatuses.smsInitial.text}
                      </Label>
                    </div>
                  </div>
                )}
                {reminderStatuses.emailInitial.enabled && (
                  <div className="row with-margin-top-10">
                    <div className="col col-4 text-grey">
                      Initial Notification (Email)
                    </div>
                    <div className="col d-flex">
                      <Checkbox
                        className="with-label"
                        checked={reminderStatuses.emailInitial.sent}
                      />
                      <Label className="d-inline no-margin-bottom">{reminderStatuses.emailInitial.text}</Label>
                    </div>
                  </div>
                )}
                {reminderStatuses.smsDue.enabled && (
                  <div className="row with-margin-top-10">
                    <div className="col col-4 text-grey">
                      Due Today Reminder (SMS)
                    </div>
                    <div className="col d-flex">
                      <Checkbox
                        className="with-label"
                        checked={reminderStatuses.smsDue.sent}
                      />
                      <Label className="d-inline no-margin-bottom">
                        {reminderStatuses.smsDue.text}
                      </Label>
                    </div>
                  </div>
                )}
                {reminderStatuses.emailDue.enabled && (
                  <div className="row with-margin-top-10">
                    <div className="col col-4 text-grey">
                      Due Today Reminder (Email)
                    </div>
                    <div className="col d-flex">
                      <Checkbox
                        className="with-label"
                        checked={reminderStatuses.emailDue.sent}
                      />
                      <Label className="d-inline no-margin-bottom">{reminderStatuses.emailDue.text}</Label>
                    </div>
                  </div>
                )}
                {/* {reminderStatuses.sms3Day.enabled && (
                  <div className="row with-margin-top-10">
                    <div className="col col-4 text-grey">
                      3 Day Reminder (SMS)
                    </div>
                    <div className="col d-flex">
                      <Checkbox
                        className="with-label"
                        checked={reminderStatuses.sms3Day.sent}
                      />
                      <Label className="d-inline no-margin-bottom">{reminderStatuses.sms3Day.text}</Label>
                    </div>
                  </div>
                )}
                {reminderStatuses.email3Day.enabled && (
                  <div className="row with-margin-top-10">
                    <div className="col col-4 text-grey">
                      3 Day Reminder (Email)
                    </div>
                    <div className="col d-flex">
                      <Checkbox
                        className="with-label"
                        checked={reminderStatuses.email3Day.sent}
                      />
                      <Label className="d-inline no-margin-bottom">{reminderStatuses.email3Day.text}</Label>
                    </div>
                  </div>
                )}
                {reminderStatuses.sms1Day.enabled && (
                  <div className="row with-margin-top-10">
                    <div className="col col-4 text-grey">
                      1 Day Reminder (SMS)
                    </div>
                    <div className="col d-flex">
                      <Checkbox
                        className="with-label"
                        checked={reminderStatuses.sms1Day.sent}
                      />
                      <Label className="d-inline no-margin-bottom">{reminderStatuses.sms1Day.text}</Label>
                    </div>
                  </div>
                )}
                {reminderStatuses.email3Day.enabled && (
                  <div className="row with-margin-top-10">
                    <div className="col col-4 text-grey">
                      1 Day Reminder (Email)
                    </div>
                    <div className="col d-flex">
                      <Checkbox
                        className="with-label"
                        checked={reminderStatuses.email3Day.sent}
                      />
                      <Label className="d-inline no-margin-bottom">{reminderStatuses.email1Day.text}</Label>
                    </div>
                  </div>
                )} */}
              </SectionGroup>
            </div>
          </div>
          <div className="row with-margin-top-extra">
            <div className="col">
              {this.props.paymentRequests.currentPaymentRequest?.paymentCategory === 'individual-request' && (
                <PaymentCollectionsTableCustomers
                  {...this.props.paymentCollections}
                  headerTitle="Payment Collections"
                  appReady={this.props.appReady}
                  actions={this.props.actions}
                  saveFilters={false}
                  isLoading={this.props.paymentCollections.isLoading}
                  persistentFilterConfig={{
                    paymentRequestId: paymentRequest.id,
                  }}
                  selectPaymentCollection={this.props.actions.selectPaymentRequest}
                />
              )}
              {this.props.paymentRequests.currentPaymentRequest?.paymentCategory === 'team-request' && (
                <PaymentCollectionsTableTeams
                  {...this.props.paymentCollections}
                  headerTitle="Payment Collections"
                  appReady={this.props.appReady}
                  actions={this.props.actions}
                  saveFilters={false}
                  isLoading={this.props.paymentCollections.isLoading}
                  persistentFilterConfig={{
                    paymentRequestId: paymentRequest.id,
                  }}
                  selectPaymentCollection={this.props.actions.selectPaymentRequest}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
